import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {useThemeMode} from '../../../../_metronic/partials'

interface Props<T extends object> {
  row: Row<T>
}

const CustomRow: FC<Props<any>> = ({row}) => {
  const {mode} = useThemeMode()
  const {key, ...rowProps} = row.getRowProps()
  const bg = mode === 'dark' ? 'rgb(30, 30, 45)' : 'white'

  return (
    <>
      <tr key={key} {...rowProps} style={{backgroundColor: bg}}>
        {row.cells.map((cell) => {
          const {key, ...cellProps} = cell.getCellProps()
          return (
            <td
              key={key}
              {...cellProps}
              className={clsx({
                'text-end min-w-100px relative': cell.column.id === 'actions relative',
              })}
            >
              {cell.render('Cell')}
            </td>
          )
        })}
      </tr>
      <tr style={{height: '10px'}}></tr>
    </>
  )
}

export {CustomRow}
